import React, { useState, useContext } from 'react';
import { TableCell, Typography, ThemeProvider, Button, Backdrop, CircularProgress} from '@mui/material';
import {Context, theme} from '../App';
import { API } from '../conf';
import SorTable from './sortable';

export default function Import(props) {
    const {updateConnect} = useContext(Context)
    const [loading, setLoad] = useState(false)
    const [msg, setMsg] = useState(props.msg)

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Prénoms", sortable: true, sortBy:(el)=>el.prenoms.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.prenoms}</TableCell>},
    ]

    const handleEnregistrer = ()=>{
        setLoad(true)
        fetch(API.concat('/beneficiaire_repas/registe_many'),{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify(props.users.filter(user => user.nom && user.prenoms))
        })
        .then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    props.updateData(old=>[...old, ...json])
                    props.close()
                } else setMsg("Oups! échec de l'enregistrement, veuillez réessayer ultérieurement")
            } 
        })
    }

    return(
        <ThemeProvider theme={theme}>
        {props.users ?
        <div style={{display: 'flex', justifyContent:'center', flexDirection: 'column'}}>
            <SorTable data={props.users} table={table} rowsPerPage={100} rowsPerPageOptions={[50, 100, 300]}/>
            <div style={{display: 'flex', justifyContent: 'center', flexDirection:'row'}}>
                <Button variant='contained' style={{marginRight:20}} color='grey' onClick={()=> props.close()}>Annuler</Button>
                <Button variant='contained' color='verdigris' onClick={handleEnregistrer}>Enregistrer</Button>
            </div>
            <Backdrop open={loading}>
                <CircularProgress/>
            </Backdrop>
        </div>
        : <div style={{minHeight:260, minWidth:500}}>
            <Typography variant='subtitle1' fontWeight='bold' textAlign={'center'} style={{color: 'coral'}}>{props.msg}</Typography>
            {msg.toLowerCase().includes('entêtes invalides') && <><Typography>Les entêtes valides sont les suivants: 'nom', 'prenoms'</Typography>
            <Typography fontWeight='bold'>Sensible à la casse, Attention aux accents !</Typography></>}
        </div>}
        </ThemeProvider>
    )
}